
<i18n>
    {
    "en": {
    "interact": "Interact with this environment to discover the HELIX collection"
    },

    "fr": {
    "interact": "Interagissez avec cet environnement pour découvrir la collection HELIX."
    },

    "pl": {
    "interact": "Zainspirowane naturą - odkryj i sprawdź kolekcję HELIX"
    },

    "de": {
    "interact": "Interagieren Sie mit der Umgebung, um die HELIX Kollektion zu entdecken"
    }

    }
</i18n>

<template>
    <div class="Pane">
        <div id="panorama" class="panorama" v-bind:class="serie"
             @mouseup="onMouseUp"
             @touchmove="onTouchMove"
             @touchend="onTouchEnd">
        </div>
        <div :class="['overlay', overlayProtector ? 'overlayShow' : 'overlayHidden']">
            <div class="icon_360"></div>
            <p>
                {{ $t('interact') }}
            </p>
        </div>
        <button class="overlay-protector" @click="overlayProtector = false" :style="{ display: overlayProtector ? 'block' : 'none' }"></button>
    </div>
</template>

<script>
    import '../lib/pannellum/pannellum.js'
    import '../lib/pannellum/pannellum.css'
    import '../css/creabel.css'

    /* eslint-disable */

    import loading from '../assets/loading.jpg';


    export default {
        name: 'Pane',

        props: {
            debug: { type: Boolean, default: false },
            scene: String,
        },
        data() {
            return {
                viewer: null,
                info: '',
                rafId: -1,
                overlayProtector: true
            }
        },
        mounted() {
            this.load()
            //this.rafId = window.requestAnimationFrame(this.loop)
            this.$root.$on('changeSceneClick', (val) => {
                this.loadScene(val)
            })
        },
        beforeDestroy() {
            this.viewer.destroy()
            //window.cancelAnimationFrame(this.rafId)
        },
        computed: {
            serie: function () {
                return (this.scene.split("_")[0])
            }
        },
        methods: {
            load() {
                // eslint-disable-next-line
                console.log("PANE");

                let options = {
                    default: {
                        "firstScene": this.scene,
                        //"author": "INTEGENCE",
                        "preview": loading,
                        "previewTitle": "",
                        "sceneFadeDuration": 1000,

                        "hfov": 110,
                        "minYaw": -120,
                        "maxYaw": 120,
                        "minPitch": -90,
                        "maxPitch": 90,
                        "minHfov": 80,
                        "maxHfov": 120,
                        "pitch": 20,

                        "autoLoad": true,
                        "hotSpotDebug": false
                    },

                    scenes: {

                        "intro": {
                            "title": "LOADING",
                            "pitch": 0,
                            "yaw": 0,
                            "panorama": loading,
                        },

                        "select": {
                            "title": "LOADING",
                            "pitch": 20,
                            "yaw": 0,
                            "panorama": loading,
                        },



                        /* #region CRYSTAL */

                        "crystal_8_a": {
                            "title": "",
                            "yaw": 0,
                            "panorama": require("@/assets/pano/crystal_8_a.jpg"),
                            "hotSpots": require("@/assets/data/crystal_8_a.json")
                        },

                        "crystal_8_b": {
                            "title": "",
                            "yaw": 0,
                            "panorama": require("@/assets/pano/crystal_8_b.jpg"),
                            "hotSpots": require("@/assets/data/crystal_8_b.json")
                        },

                        "crystal_14_a": {
                            "title": "",
                            "yaw": 0,
                            "panorama": require("@/assets/pano/crystal_14_a.jpg"),
                            "hotSpots": require("@/assets/data/crystal_14_a.json")
                        },

                        "crystal_14_b": {
                            "title": "",
                            "yaw": 0,
                            "panorama": require("@/assets/pano/crystal_14_b.jpg"),
                            "hotSpots": require("@/assets/data/crystal_14_b.json")
                        },

                        "crystal_23_a": {
                            "title": "",
                            "yaw": 0,
                            "panorama": require("@/assets/pano/crystal_23_a.jpg"),
                            "hotSpots": require("@/assets/data/crystal_23_a.json")
                        },

                        "crystal_23_b": {
                            "title": "",
                            "yaw": 0,
                            "panorama": require("@/assets/pano/crystal_23_b.jpg"),
                            "hotSpots": require("@/assets/data/crystal_23_b.json")
                        },

                        /* #endregion */


                        /* #region TWEED */

                        "tweed_10_10_a": {
                            "title": "",
                            "yaw": 0,
                            "panorama": require("@/assets/pano/tweed_10_10_a.jpg"),
                            "hotSpots": require("@/assets/data/tweed_10_10_a.json")
                        },

                        "tweed_10_10_b": {
                            "title": "",
                            "yaw": 0,
                            "panorama": require("@/assets/pano/tweed_10_10_b.jpg"),
                            "hotSpots": require("@/assets/data/tweed_10_10_b.json")
                        },

                        "tweed_10_14_a": {
                            "title": "",
                            "yaw": 0,
                            "panorama": require("@/assets/pano/tweed_10_14_a.jpg"),
                            "hotSpots": require("@/assets/data/tweed_10_14_a.json")
                        },

                        "tweed_10_14_b": {
                            "title": "",
                            "yaw": 0,
                            "panorama": require("@/assets/pano/tweed_10_14_b.jpg"),
                            "hotSpots": require("@/assets/data/tweed_10_14_b.json")
                        },

                        "tweed_10_20_a": {
                            "title": "",
                            "yaw": 0,
                            "panorama": require("@/assets/pano/tweed_10_20_a.jpg"),
                            "hotSpots": require("@/assets/data/tweed_10_20_a.json")
                        },

                        "tweed_10_20_b": {
                            "title": "",
                            "yaw": 0,
                            "panorama": require("@/assets/pano/tweed_10_20_b.jpg"),
                            "hotSpots": require("@/assets/data/tweed_10_20_b.json")
                        },

                        "tweed_14_10_a": {
                            "title": "",
                            "yaw": 0,
                            "panorama": require("@/assets/pano/tweed_14_10_a.jpg"),
                            "hotSpots": require("@/assets/data/tweed_14_10_a.json")
                        },

                        "tweed_14_10_b": {
                            "title": "",
                            "yaw": 0,
                            "panorama": require("@/assets/pano/tweed_14_10_b.jpg"),
                            "hotSpots": require("@/assets/data/tweed_14_10_b.json")
                        },

                        "tweed_14_14_a": {
                            "title": "",
                            "yaw": 0,
                            "panorama": require("@/assets/pano/tweed_14_14_a.jpg"),
                            "hotSpots": require("@/assets/data/tweed_14_14_a.json")
                        },

                        "tweed_14_14_b": {
                            "title": "",
                            "yaw": 0,
                            "panorama": require("@/assets/pano/tweed_14_14_b.jpg"),
                            "hotSpots": require("@/assets/data/tweed_14_14_b.json")
                        },

                        "tweed_14_20_a": {
                            "title": "",
                            "yaw": 0,
                            "panorama": require("@/assets/pano/tweed_14_20_a.jpg"),
                            "hotSpots": require("@/assets/data/tweed_14_20_a.json")
                        },

                        "tweed_14_20_b": {
                            "title": "",
                            "yaw": 0,
                            "panorama": require("@/assets/pano/tweed_14_20_b.jpg"),
                            "hotSpots": require("@/assets/data/tweed_14_20_b.json")
                        },

                        "tweed_20_10_a": {
                            "title": "",
                            "yaw": 0,
                            "panorama": require("@/assets/pano/tweed_20_10_a.jpg"),
                            "hotSpots": require("@/assets/data/tweed_20_10_a.json")
                        },

                        "tweed_20_10_b": {
                            "title": "",
                            "yaw": 0,
                            "panorama": require("@/assets/pano/tweed_20_10_b.jpg"),
                            "hotSpots": require("@/assets/data/tweed_20_10_b.json")
                        },

                        "tweed_20_14_a": {
                            "title": "",
                            "yaw": 0,
                            "panorama": require("@/assets/pano/tweed_20_14_a.jpg"),
                            "hotSpots": require("@/assets/data/tweed_20_14_a.json")
                        },

                        "tweed_20_14_b": {
                            "title": "",
                            "yaw": 0,
                            "panorama": require("@/assets/pano/tweed_20_14_b.jpg"),
                            "hotSpots": require("@/assets/data/tweed_20_14_b.json")
                        },

                        "tweed_20_20_a": {
                            "title": "",
                            "yaw": 0,
                            "panorama": require("@/assets/pano/tweed_20_20_a.jpg"),
                            "hotSpots": require("@/assets/data/tweed_20_20_a.json")
                        },

                        "tweed_20_20_b": {
                            "title": "",
                            "yaw": 0,
                            "panorama": require("@/assets/pano/tweed_20_20_b.jpg"),
                            "hotSpots": require("@/assets/data/tweed_20_20_b.json")
                        },

                        /* #endregion */


                        /* #region VERDE */

                        "verde_8_8_a": {
                            "title": "",
                            "yaw": 0,
                            "panorama": require("@/assets/pano/verde_8_8_a.jpg"),
                            "hotSpots": require("@/assets/data/verde_8_8_a.json")
                        },

                        "verde_8_8_b": {
                            "title": "",
                            "yaw": 0,
                            "panorama": require("@/assets/pano/verde_8_8_b.jpg"),
                            "hotSpots": require("@/assets/data/verde_8_8_b.json")
                        },

                        "verde_8_11_a": {
                            "title": "",
                            "yaw": 0,
                            "panorama": require("@/assets/pano/verde_8_11_a.jpg"),
                            "hotSpots": require("@/assets/data/verde_8_11_a.json")
                        },

                        "verde_8_11_b": {
                            "title": "",
                            "yaw": 0,
                            "panorama": require("@/assets/pano/verde_8_11_b.jpg"),
                            "hotSpots": require("@/assets/data/verde_8_11_b.json")
                        },

                        "verde_8_17_a": {
                            "title": "",
                            "yaw": 0,
                            "panorama": require("@/assets/pano/verde_8_17_a.jpg"),
                            "hotSpots": require("@/assets/data/verde_8_17_a.json")
                        },

                        "verde_8_17_b": {
                            "title": "",
                            "yaw": 0,
                            "panorama": require("@/assets/pano/verde_8_17_b.jpg"),
                            "hotSpots": require("@/assets/data/verde_8_17_b.json")
                        },


                        "verde_11_8_a": {
                            "title": "",
                            "yaw": 0,
                            "panorama": require("@/assets/pano/verde_11_8_a.jpg"),
                            "hotSpots": require("@/assets/data/verde_11_8_a.json")
                        },

                        "verde_11_8_b": {
                            "title": "",
                            "yaw": 0,
                            "panorama": require("@/assets/pano/verde_11_8_b.jpg"),
                            "hotSpots": require("@/assets/data/verde_11_8_b.json")
                        },

                        "verde_11_11_a": {
                            "title": "",
                            "yaw": 0,
                            "panorama": require("@/assets/pano/verde_11_11_a.jpg"),
                            "hotSpots": require("@/assets/data/verde_11_11_a.json")
                        },

                        "verde_11_11_b": {
                            "title": "",
                            "yaw": 0,
                            "panorama": require("@/assets/pano/verde_11_11_b.jpg"),
                            "hotSpots": require("@/assets/data/verde_11_11_b.json")
                        },

                        "verde_11_17_a": {
                            "title": "",
                            "yaw": 0,
                            "panorama": require("@/assets/pano/verde_11_17_a.jpg"),
                            "hotSpots": require("@/assets/data/verde_11_17_a.json")
                        },

                        "verde_11_17_b": {
                            "title": "",
                            "yaw": 0,
                            "panorama": require("@/assets/pano/verde_11_17_b.jpg"),
                            "hotSpots": require("@/assets/data/verde_11_17_b.json")
                        },


                        "verde_17_8_a": {
                            "title": "",
                            "yaw": 0,
                            "panorama": require("@/assets/pano/verde_17_8_a.jpg"),
                            "hotSpots": require("@/assets/data/verde_17_8_a.json")
                        },

                        "verde_17_8_b": {
                            "title": "",
                            "yaw": 0,
                            "panorama": require("@/assets/pano/verde_17_8_b.jpg"),
                            "hotSpots": require("@/assets/data/verde_17_8_b.json")
                        },

                        "verde_17_11_a": {
                            "title": "",
                            "yaw": 0,
                            "panorama": require("@/assets/pano/verde_17_11_a.jpg"),
                            "hotSpots": require("@/assets/data/verde_17_11_a.json")
                        },

                        "verde_17_11_b": {
                            "title": "",
                            "yaw": 0,
                            "panorama": require("@/assets/pano/verde_17_11_b.jpg"),
                            "hotSpots": require("@/assets/data/verde_17_11_b.json")
                        },

                        "verde_17_17_a": {
                            "title": "",
                            "yaw": 0,
                            "panorama": require("@/assets/pano/verde_17_17_a.jpg"),
                            "hotSpots": require("@/assets/data/verde_17_17_a.json")
                        },

                        "verde_17_17_b": {
                            "title": "",
                            "yaw": 0,
                            "panorama": require("@/assets/pano/verde_17_17_b.jpg"),
                            "hotSpots": require("@/assets/data/verde_17_17_b.json")
                        },

                        /* #endregion */

                    }
                }
                Object.assign(options, this.srcOption)
                this.viewer = window.pannellum.viewer(this.$el.getElementsByClassName("panorama")[0], options) // this.$el
                this.viewer.on('load', () => {
                    this.$emit('load')
                })
                this.viewer.on('scenechange', (val) => {
                    this.$emit('scenechange', val)
                })
                this.viewer.on('error', (err) => {
                    this.$emit('error', err)
                })
                if (this.showZoom === false) {
                    let el = this.$el.querySelector('.pnlm-zoom-controls')
                    if (el) el.style.display = 'none'
                }
                if (this.showFullscreen === false) {
                    let el = this.$el.querySelector('.pnlm-fullscreen-toggle-button')
                    if (el) el.style.display = 'none'
                }
            },
            onMouseUp() {
                if (this.debug) this.info += ' mu'
            },
            onTouchMove() {
                if (this.debug) this.info += ' tm'
            },
            onTouchEnd() {
                if (this.debug) this.info += ' te'
            },
            loadScene(val) {
                if (this.viewer) {
                    if (this.debug) this.info += ' load(' + val + ')'
                    if (val == "select") {
                        this.viewer.loadScene(val)
                    } else {
                        this.viewer.loadScene(val, this.viewer.getPitch(), this.viewer.getYaw(), this.viewer.getHfov())
                    }
                }
            },
        },



    };
</script>

<style>
</style>

<style scoped>
    .Pane {
        display: block;
        position: relative;
        width: 100%;
        height: calc(100% - 50px);
        overflow: hidden;
        text-overflow: clip;
        white-space: nowrap;
    }

    #panorama {
    }

    .pnlm-panorama-info {
        display: none;
        visibility: hidden;
    }

    .overlay-protector {
        display: block;
        position: absolute;
        z-index: 6;
        width: 100%;
        height: 100%;
        top: 0;
        background: transparent;
        border: 0;
        outline: none;
        cursor: pointer;
    }

    .overlay {
        display: block;
        position: absolute;
        z-index: 5;
        width: 100%;
        height: 100%;
        top: 0;
        text-align: center;
        transition: all 500ms ease;
        /*transition-delay: 10s;*/
        visibility: visible;
        opacity: 1;
    }

        .overlay.overlayShow {
            visibility: visible;
            opacity: 1;
        }

        .overlay.overlayHidden {
            transition-delay: 0ms;
            visibility: hidden;
            opacity: 0;
        }

        .overlay:before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: #000;
            opacity: 0.6;
        }
        /*

        .overlay:hover, .overlay:active {
            transition-delay: 0s;
            visibility: hidden;
            opacity: 0;
        }
    */

        .overlay p {
            position: relative;
            margin: auto;
            width: 50%;
            font-size: 24px;
            white-space: normal;
            color: #FFFFFF;
        }

        .overlay .icon_360 {
            background: url('~@/assets/icons/360-icon.png') no-repeat center center;
            background-size: contain;
            position: relative;
            width: 20vh;
            height: 15vh;
            margin: 15vh auto;
        }

    @media only screen and (max-device-width : 1024px) {
        .overlay p {
            width: 80%;
        }
    }
</style>